import { Resource as r, API as o } from "@coveo/platform-client";
const t = class t extends r {
  /**
   * Returns a list of search pages for the specified project.
   *
   * @param {string | undefined} projectId ID of the project for which to retrieve search pages.
   * @returns {Promise<SearchPageModel[]>} List of search pages for the specified project.
   */
  listSearchPagesByProjectId(s) {
    return this.api.get(
      this.buildPath(`${t.baseUrl}/project/id`, {
        projectid: s
      })
    );
  }
};
t.baseUrl = `/rest/organizations/${o.orgPlaceholder}/pages`;
let i = t;
export {
  i as SearchPagesInternalResource
};
//# sourceMappingURL=SearchPagesInternalResource.js.map
